<template>
    <div>
        <DInput
            ref="dateinput"
            type="date"
            add-input-classes="bg-light"
            :placeholder="__('customers.invoices.form.from_date')"
            :is-valid="compIsValid"
            :invalid-feedback="compInvalidFeedback"
            @update:value="updateValue"
        />
    </div>
</template>

<script>
export default {
    name: 'DDateInput',
    props: {
        placeholder: {
            type: String,
            required: false,
            default: () => ''
        },
        value: {
            type: String,
            default: () => ''
        },
        isValid: {
            type: Boolean,
            default: () => true
        },
        invalidFeedback: {
            type: String,
            default: () => null
        }
    },
    emits: ['update:modelValue'],
    data () {
        return {
            nonEmptyDateValidation: null
        }
    },
    computed: {
        compIsValid () {
            return this.isValid && this.nonEmptyDateValidation === null
        },
        compInvalidFeedback () {
            if (this.invalidFeedback) {
                return this.invalidFeedback
            }
            if (this.nonEmptyDateValidation) {
                return this.nonEmptyDateValidation
            }
            return null
        }
    },
    methods: {
        updateValue (newVal) {
            this.$emit('update:modelValue', newVal)
        }
    }
}
</script>
